<script>
import api from '@/command/api'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'

export default {
  name: 'main',
  data() {
    return {
      ...api.command.getState()
    }
  },
  mounted() {
    api.command.getList.call(this, {
      url: '/firm/page',
      current: 1
    })
  },
  methods: {
    getHeader() {
      return [
        {
          name: '企业名称',
          type: 'input',
          key: 'firmName'
        },
        {
          name: '电话',
          type: 'input',
          key: 'sj'
        },
        {
          name: '统一社会信用代码',
          type: 'input',
          key: 'xydm'
        }
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'firmId',
          title: 'ID',
          type: 'lt-90',
          isId: true,
          sorter: (a, b) => a.firmId - b.firmId
        },
        {
          dataIndex: 'firmName',
          title: '企业名称',
          filter: true,
          type: 'lt-100',
          sorter: (a, b) => a.firmName.length - b.firmName.length
        },
        {
          dataIndex: 'addr',
          title: '地址',
          type: 'lt-100',
          sorter: (a, b) => a.addr.length - b.addr.length
        },
        {
          dataIndex: 'xydm',
          title: '统一社会信用代码',
          type: 'lt-100',
          sorter: (a, b) => a.xydm.length - b.xydm.length
        },
        {
          dataIndex: 'sj',
          title: '电话',
          type: 'lt-100',
          sorter: (a, b) => a.sj - b.sj
        },
        {
          dataIndex: 'status',
          title: '状态',
          width: '60px',
          type: 'badge',
          onExport: records => {
            return ['正常', '失效'][records]
          },
          filters: [
            {
              text: '正常',
              value: '0'
            },
            {
              text: '失效',
              value: '1'
            }
          ],
          onFilter: (value, record) => record.status == value,
          render(data) {
            return {
              showDot: true,
              name: data == 0 ? '正常' : '失效',
              color: data == 0 ? 'green' : 'red'
            }
          }
        },
        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          width: '10%',
          typeData: ({ records }) => {
            return [
              //   {
              //     name: records.status == 0 ? '失效' : '正常',
              //     onClick: () => {}
              //   },
              {
                name: '分配用户',
                onClick: () => this.$router.push(`/infoMain/distriBution?id=${records.firmId}`)
              },
              {
                name: '编辑',
                onClick: () => this.$router.push(`/infoMain/mainDetail?id=${records.firmId}`)
              },
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认是否删除吗?',
                onClick: () =>
                  api.command.del.call(this, {
                    url: `/firm/${records.firmId}`
                  })
              }
            ]
          }
        }
      ]
    },
    getButton() {
      return [
        {
          name: '添加',
          type: 'primary',
          icon: 'plus',
          onClick: () => this.$router.push('/infoMain/mainDetail')
        }
        // {
        //   viewType: 'menu',
        //   name: '更多操作',
        //   isBatch: true,
        //   children: [
        //     {
        //       name: '批量删除',
        //       onClick: data => {
        //
        //       }
        //     }
        //   ]
        // }
      ]
    }
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        button={this.getButton()}
        records={this.records}
      />
    )
  }
}
</script>
